import { useState, useEffect, useCallback, useRef } from 'react'


export const useApiData = (intiData, initparams, apiCallback, autoload = true) => {
    const [params, setParams] = useState(initparams);
    const [apiautoload, setApiAutoLoad] = useState(autoload)
    const [data, setData] = useState(intiData)
    const [loading, setLoading] = useState(autoload)
    const apiCallbackRef = useRef(apiCallback)

    // Update ref when callback changes
    useEffect(() => {
        apiCallbackRef.current = apiCallback
    }, [apiCallback])

    const loadData = useCallback((newParams) => {
        setParams(newParams)
        setLoading(true)
        apiCallbackRef.current(newParams, (data) => {
            setApiAutoLoad(false)
            setData(data)
            setLoading(false)
        })
    }, []) // Empty deps - loadData is stable

    useEffect(() => {
        if (apiautoload) {
            loadData(params)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiautoload, params]) // Only run when autoload or params change, loadData is stable

    return [data, params, loading, loadData]
}

